import React from 'react';

import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';

import DocumentsUsersListItem from './DocumentsUsersListItem';

interface DocumentsUserFoldersProps {
	folderUid: string;
}

export default function DocumentsUserFolders({ folderUid }: DocumentsUserFoldersProps) {
	return (
		<div className="p-8">
			<DetailsSectionWrapper disablePadding>
				<ViewList
					module="sys_documents_folders_users"
					defaultFilters={[{ filt_field: 'fold_uid', filt_clause: 'equals', filt_value: folderUid }]}
					itemLayout={DocumentsUsersListItem}
				/>
			</DetailsSectionWrapper>
		</div>
	);
}
